









































































































import { Component, Prop, Emit } from 'vue-property-decorator';
import Form from '@/components/form-base';
import {DialogForm, FormOverlay} from '@/components/bwaff';
import {mixins} from 'vue-class-component';
import IntegrationMixin from '@/views/settings/integrations/custom-integrations/mixins/integration-mixin';

@Component({
  components: {
    FormOverlay,
    DialogForm,
  }
})
export default class ListPickerDialog extends  mixins(Form,IntegrationMixin) {
  edit: boolean = true;
  search: string = '';

  @Prop()
  itemsOthers: any[];

  @Prop({default: []})
  itemsOthersTile: any[];

  @Prop()
  itemsIntegrated: any[];
  
  @Prop()
  readArticleUrl: string;

  @Prop()
  title: string;

  @Prop({default: true})
  hasHelp: boolean;

  activeItem: any = null;

  @Prop({default: true})
  networkListInTileFormat: any;

  @Emit('update:activeItem')
  onUpdateActiveItem(value: any) {
    this.activeItem = value;
  }

  @Emit('confirm')
  onConfirm() {}

  get computedItemsOthers() {
    return this.itemsOthers
      .filter((e: any) => e.name.toLowerCase().includes(this.search.toLowerCase()))
  };

  get computedItemsTileOthers() {
    return this.itemsOthersTile
      .filter((e: any) => e.name.toLowerCase().includes(this.search.toLowerCase()))
  };

  get computedItemsIntegrated() {
    return this.itemsIntegrated
      .filter((e: any) => {
        const integrationInstance = this.integrationsData[e.integrationType];
        return e.name.toLowerCase().includes(this.search.toLowerCase())
          && integrationInstance
          && integrationInstance.img
      })
  };

  close() {
    this.$emit('close');
  }
}
